import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-xxl" }
const _hoisted_2 = { class: "d-flex flex-column h-100 justify-content-lg-center" }
const _hoisted_3 = { class: "w-lg-500px bg-white w-100 rounded p-10 m-10 p-lg-15 mx-auto" }
const _hoisted_4 = { class: "text-center mb-10" }
const _hoisted_5 = { class: "text-main mb-3" }
const _hoisted_6 = { class: "text-main-light fw-bold fs-4" }
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = {
  class: "d-flex flex-wrap justify-content-center pb-lg-0",
  style: {"gap":"10px"}
}
const _hoisted_9 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder flex-grow-1"
}
const _hoisted_10 = { class: "indicator-label" }
const _hoisted_11 = { class: "indicator-progress" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-content-center flex-column align-items-center"
}
const _hoisted_14 = { class: "text-center mb-10" }
const _hoisted_15 = { class: "text-main mb-3" }
const _hoisted_16 = { class: "text-main-light fw-bold fs-4" }
const _hoisted_17 = { class: "d-flex flex-wrap justify-content-center mt-10" }
const _hoisted_18 = { class: "indicator-label" }
const _hoisted_19 = { class: "indicator-progress" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_21 = { class: "text-gray-400 text-center fw-bold fs-4 mt-5" }
const _hoisted_22 = { class: "text-center mb-10" }
const _hoisted_23 = { class: "text-main mb-3" }
const _hoisted_24 = { class: "fv-row mb-10" }
const _hoisted_25 = { class: "fv-row mb-10" }
const _hoisted_26 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_27 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary px-14 fw-bolder"
}
const _hoisted_28 = { class: "indicator-label" }
const _hoisted_29 = { class: "indicator-progress" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.currentStepIndex === 1)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              class: "form w-100",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onSubmitForgotPassword()), ["prevent"])),
              model: _ctx.resetForm,
              ref: "resetFormRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("forgetPassword")), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("enterEmailToResetPassword")), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_form_item, {
                    prop: "email",
                    rules: [
                {
                  required: true,
                  message: _ctx.$t('emailRequired'),
                  trigger: 'change',
                },
              ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "fs-3",
                        modelValue: _ctx.resetForm.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.resetForm.email) = $event)),
                        type: "email",
                        placeholder: _ctx.$t('email'),
                        autocomplete: "off"
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("submit")), 1),
                    _createElementVNode("span", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + " ", 1),
                      _hoisted_12
                    ])
                  ], 512),
                  _createVNode(_component_router_link, {
                    to: { name: 'sign-up' },
                    class: "btn btn-lg btn-dark-light border border-dark fw-bolder flex-grow-1 bg-hover-dark text-hover-white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true),
        (_ctx.currentStepIndex === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.$t("verificationCode")), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("pleaseEnterCode")), 1)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_otp_input, {
                  ref: "otpInput",
                  "input-classes": [
                'otp-input',
                {
                  error: _ctx.otpError,
                },
              ],
                  separator: "",
                  "num-inputs": 4,
                  "should-auto-focus": true,
                  "is-input-num": true,
                  onOnChange: _ctx.handleOnChange,
                  onOnComplete: _ctx.handleOnComplete
                }, null, 8, ["input-classes", "onOnChange", "onOnComplete"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.verifiyOtp && _ctx.verifiyOtp(...args)), ["prevent"])),
                  ref: "submitButton",
                  id: "kt_password_reset_submit",
                  class: "btn btn-lg btn-primary px-14 fw-bolder flex-grow-1"
                }, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("confirm")), 1),
                  _createElementVNode("span", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + " ", 1),
                    _hoisted_20
                  ])
                ], 512)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createTextVNode(_toDisplayString(_ctx.$t("code_not_send")) + " ", 1),
                _createElementVNode("a", {
                  href: "/send-again",
                  class: "fw-bolder text-decoration-underline",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.sendCodeAgain()), ["prevent"]))
                }, _toDisplayString(_ctx.$t("send_again")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentStepIndex === 3)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 2,
              class: "form w-100",
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.setNewPassword()), ["prevent"])),
              model: _ctx.newPasswordForm,
              ref: "newPasswordRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h1", _hoisted_23, _toDisplayString(_ctx.$t("resetPassword")), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_el_form_item, {
                    prop: "password",
                    rules: [
                {
                  required: true,
                  message: _ctx.$t('passwordRequired'),
                  trigger: 'change',
                },
              ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "fs-3",
                        modelValue: _ctx.newPasswordForm.password,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newPasswordForm.password) = $event)),
                        type: "password",
                        placeholder: _ctx.$t('newPassword'),
                        autocomplete: "off"
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_el_form_item, {
                    prop: "confirmPassword",
                    rules: [
                {
                  required: true,
                  message: _ctx.$t('passwordRequired'),
                  trigger: 'change',
                },
              ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "fs-3",
                        modelValue: _ctx.newPasswordForm.confirmPassword,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPasswordForm.confirmPassword) = $event)),
                        type: "password",
                        placeholder: _ctx.$t('confirmNewPassword'),
                        autocomplete: "off"
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("save")), 1),
                    _createElementVNode("span", _hoisted_29, [
                      _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + " ", 1),
                      _hoisted_30
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}